import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { ChevronLeft } from "lucide-react";

function isInstalled() {
  try {
    return window.matchMedia("(display-mode: standalone)").matches || window.navigator.standalone === true;
  } catch { return false; }
}

/** A back arrow for the installed app, which has no browser back button. Not shown on the home page or in a normal browser tab. */
export function BackButton() {
  const nav = useNavigate();
  const loc = useLocation();
  const [app, setApp] = useState(false);
  useEffect(() => setApp(isInstalled()), []);

  if (!app || loc.pathname === "/") return null;

  // "default" is the first page this visit opened, so there is nothing behind it to go back to.
  const back = () => (loc.key && loc.key !== "default" ? nav(-1) : nav("/"));

  return (
    <button
      type="button"
      onClick={back}
      data-testid="back-button"
      aria-label="Go back"
      className="mr-1 rounded-full p-2 text-amber-100/80 transition-colors hover:bg-white/10 hover:text-amber-50"
    >
      <ChevronLeft className="h-5 w-5" aria-hidden="true" />
    </button>
  );
}